import { Space } from "antd";
import { DownloadOutlined, EyeOutlined, SendOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { parseDate } from "../../../core/methods/sorterMethods";
import { cellWidth } from "../../../core/methods/tableCellWidth";

export const caseDetailsData = {
  applicantName: "Giftson Keishing",
  caseId: "Tel/HV/0347979/2026",
  orderedBy: "GovindaBika",
  clientName: "Tech Mahindra Limited",
  employeeId: "6322731",
  deptLoc: "Gurgaon",
  caseType: "applicant_invite_b",
  caseReceiveDate: "07 Apr 2026",
  slaStartDate: "07 Apr 2026",
  dueDate: "22 Apr 2026",
  completionDate: "22 Apr 2026",
  dispatchedStatus: "Dispatched",
  tat: "10",
  joiningDate: "06-04-2026",
  interimStatus: "N/A",
  finalReportColourCode: "GREEN",
  interimReportDate: "N/A",
  finalReportDate: "22-04-2026",
  packageOrdered:
    "PAN,1 Highest Education,Last Employment,Current Address,OFAC,AADHAAR NUMBER",
  packageInitiated:
    "Pan Card - 1,Education - 1,Employment - 1,Address - 1,Office of Foreign Assets Control (OFAC/SDN) - 1,Aadhaar Number Validation - 1",
  packageOutOfScope: "Out Of Scope",
  lastUpdated: "22-04-2026",
  totalChecks: 6,
  stopped: 0,
  completed: 4,
  insuffExpire: 0,
  wip: 0,
  hrPendency: 0,
};

export const caseSummaryData = [
  {
    key: "1",
    lastUpdated: "22-04-2026",
    totalChecks: 6,
    stopped: 0,
    completed: 4,
    insuffExpire: 0,
    wip: 0,
    hrPendency: 0,
  },
];

export const dummyData_report = [
  {
    key: "1",
    caseId: "374500",
    completionDate: "",
    reportType: "INTERIM",
    reportStatus: "GREEN",
    reportDispatch: "09-05-2026",
  },
  {
    key: "2",
    caseId: "374500",
    completionDate: "",
    reportType: "FINAL",
    reportStatus: "Orange",
    reportDispatch: "16-05-2026",
  },
];

export const checksHistoryData = [
  {
    key: 1,
    sno: 1,
    check: "Aadhaar Number Validation - 1",
    referenceId: "365717-2608574/2026-ADNV-1",
    keyValue: "********5963",
    activityView: true,
    currentStatus: "Check Complete (Online)",
    startDate: "28-04-2026",
    completedDate: "01-05-2026",
    history: "",
    colorCode: "Green",
    ruleRemarks: "",
    reportRemarks: "Details Verified",
  },
  {
    key: 2,
    sno: 2,
    check: "Education - 1",
    referenceId: "365717-2608573/2026-EDU-1",
    keyValue:
      "Jagran Institute of Management Dr APJ Abdul Kalam Technical University",
    activityView: true,
    currentStatus: "Check Complete (Online Database)",
    startDate: "28-04-2026",
    completedDate: "29-04-2026",
    history: "",
    colorCode: "Green",
    ruleRemarks: "",
    reportRemarks: "Details Verified",
  },
  {
    key: 3,
    sno: 3,
    check: "Employment - 1",
    referenceId: "365717-2608575/2026-EMP-1",
    keyValue: "INDIAMART INTERMESH LIMITED",
    activityView: true,
    currentStatus: "Check Complete (Email Verification)",
    startDate: "28-04-2026",
    completedDate: "04-05-2026",
    history: "",
    colorCode: "Green",
    ruleRemarks: "",
    reportRemarks: "Details Verified",
  },
  {
    key: 4,
    sno: 4,
    check: "Office of Foreign Assets Control (OFAC/SDN) - 1",
    referenceId: "365717-2608571/2026-OFAC-1",
    keyValue: "Shalini Yadav",
    activityView: true,
    currentStatus: "Check Complete (Database)",
    startDate: "28-04-2026",
    completedDate: "01-05-2026",
    history: "",
    colorCode: "Green",
    ruleRemarks: "",
    reportRemarks: "Details Verified",
  },
  {
    key: 5,
    sno: 5,
    check: "PAN Card - 1",
    referenceId: "365717-2608572/2026-PAN-1",
    keyValue: "******040C",
    activityView: true,
    currentStatus: "Check Complete (Database)",
    startDate: "28-04-2026",
    completedDate: "28-04-2026",
    history: "",
    colorCode: "Green",
    ruleRemarks: "",
    reportRemarks: "Details Verified",
  },
];

export const outOfScopeData = [
  {
    key: 1,
    sno: 1,
    check: "Employment - 2",
    reason: "Candidate have no further employment",
  },
];

// ======= Columns ========
export const columns = [
  {
    title: "LAST UPDATED",
    dataIndex: "lastUpdated",
    sorter: (a: any, b: any) =>
      parseDate(a.lastUpdated).getTime() - parseDate(b.lastUpdated).getTime(),
  },
  {
    title: "TOTAL CHECKS",
    dataIndex: "totalChecks",
    sorter: (a: any, b: any) => a.totalChecks - b.totalChecks,
  },
  {
    title: "STOPPED",
    dataIndex: "stopped",
    sorter: (a: any, b: any) => a.stopped - b.stopped,
  },
  {
    title: "COMPLETED",
    dataIndex: "completed",
    sorter: (a: any, b: any) => a.completed - b.completed,
  },
  // {
  //   title: "INSUFF EXPIRE",
  //   dataIndex: "insuffExpire",
  //   sorter: (a: any, b: any) => a.insuffExpire - b.insuffExpire,
  // },
  {
    title: "WIP",
    dataIndex: "wip",
    sorter: (a: any, b: any) => a.wip - b.wip,
  },
  {
    title: "HR PENDENCY",
    dataIndex: "hrPendency",
    sorter: (a: any, b: any) => a.hrPendency - b.hrPendency,
  },
];

// columns report
export const columns_report: ColumnsType<any> = [
  {
    title: "Case Id",
    dataIndex: "caseId",
    key: "caseId",
    onCell: () => cellWidth(100),
  },
  {
    title: "Recheck Report Completion Date",
    dataIndex: "completionDate",
    key: "completionDate",
    // onCell: () => cellWidth(200),
  },
  {
    title: "Report Type",
    dataIndex: "reportType",
    key: "reportType",
    onCell: () => cellWidth(130),
  },
  {
    title: "Report Status",
    dataIndex: "reportStatus",
    key: "reportStatus",
    onCell: () => cellWidth(130),
    render: (text) => <span>{text}</span>,
  },
  {
    title: "Report Dispatch",
    dataIndex: "reportDispatch",
    key: "reportDispatch",
    onCell: () => cellWidth(160),
  },
  {
    title: "Report Action",
    key: "action",
    render: (_, record) => (
      <Space>
        <button type="button" className="btn btn-sm btn-primary px-2 py-1">
          <SendOutlined />
        </button>
        <button type="button" className="btn btn-sm btn-primary px-2 py-1">
          <EyeOutlined />
        </button>
        <button type="button" className="btn btn-sm btn-primary px-2 py-1">
          <DownloadOutlined />
        </button>
      </Space>
    ),
  },
];

// // columns_checksHistory
// export const columns_checksHistory = [
//   {
//     title: "S.No",
//     dataIndex: "sno",
//     key: "sno",
//     width: 80,
//   },
//   {
//     title: "Checks",
//     dataIndex: "check",
//     key: "check",
//     onCell: () => cellWidth(200),
//   },
//   {
//     title: "Key Value",
//     dataIndex: "keyValue",
//     key: "keyValue",
//     onCell: () => cellWidth(250),
//   },
//   {
//     title: "Activity View",
//     dataIndex: "activityView",
//     key: "activityView",
//     align: "center",
//     render: () => (
//       <>
//         <EyeOutlined onClick={()=>set} />
//       </>
//     ),
//   },
//   {
//     title: "Check Current Status",
//     dataIndex: "currentStatus",
//     key: "currentStatus",
//     onCell: () => cellWidth(150),
//   },
//   {
//     title: "Start Date",
//     dataIndex: "startDate",
//     key: "startDate",
//     onCell: () => cellWidth(130),
//   },
//   {
//     title: "Completed Date",
//     dataIndex: "completedDate",
//     key: "completedDate",
//   },
//   {
//     title: "History",
//     dataIndex: "history",
//     key: "history",
//   },
//   {
//     title: "Color Code",
//     dataIndex: "colorCode",
//     key: "colorCode",
//   },
//   {
//     title: "Rule Remarks",
//     dataIndex: "ruleRemarks",
//     key: "ruleRemarks",
//   },
//   {
//     title: "Report Remarks",
//     dataIndex: "reportRemarks",
//     key: "reportRemarks",
//   },
// ];

// columns_outOfScope
export const columns_outOfScope = [
  {
    title: "S.No",
    dataIndex: "sno",
    key: "sno",
    width: 80,
  },
  {
    title: "Checks",
    dataIndex: "check",
    key: "check",
  },
  {
    title: "Out Of Scope Reason",
    dataIndex: "reason",
    key: "reason",
  },
];
